import * as DashboardConstants from "../../constants/DashboardConstants";
import {isEnglish} from "../../common/Translator";
import {getFirstNotEmptyObj, getFirstNotNullObj} from "../../common/NamaCommon";
import {calcChartTitle} from "../highCharts/HighGaugeDrawer";

function tableColLocalStorageKey(userDashboardChartLine, index) {
    return userDashboardChartLine.widgetId + "" + index;
}

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @return {JQuery | jQuery | HTMLElement}
 */
export function createGridFlexTable(userDashboardChartLine, h, w, widget) {
    let parameters = userDashboardChartLine.parameters;
    let title = calcChartTitle(userDashboardChartLine);
    let values = userDashboardChartLine.resultSet;
    let arabicHeader = parameters[DashboardConstants.Param_TableArabicHeader];
    let englishHeader = parameters[DashboardConstants.Param_TableEnglishHeader];
    let inHTML = parameters[DashboardConstants.Param_INHTML];
    let colsWidths = parameters[DashboardConstants.Param_ColumnsWidths];
    let widths = null;
    if (colsWidths)
        widths = colsWidths.split(",");
    let encoded = true;
    if (inHTML && inHTML.toLowerCase() === "true")
        encoded = false;
    let headers = {};
    if (isEnglish())
        headers = englishHeader;
    else
        headers = arabicHeader;
    headers = getFirstNotEmptyObj(headers, arabicHeader, englishHeader);
    let headersCols = {};
    if (headers) {
        headersCols = headers.split(",");
    }
    let columns = [];
    let colWidth = (w - 50) / values.headrNames.length;
    for (let i = 0; i < values.headrNames.length; i++) {
        let currWidth = widths ? parseFloat(widths[i]) : null;
        let col = {
            field: values.headrNames[i].replaceAll(" ", "_") || "c" + (i + 1), title: headersCols[i] || "-", encoded: encoded,
            headerAttributes: {"class": "nama-col-header"},
            aggregates: ["count", "min", "max", "average", "sum"],
            groupFooterTemplate: "total: #: count #, min: #: min #, max: #: max #, average: #: average #, sum: #: sum #"
        };
        columns.push(col);
        if (i < values.headrNames.length - 1)
            col.width = parseFloat(getFirstNotNullObj(localStorage.getItem(tableColLocalStorageKey(userDashboardChartLine, i)), currWidth, colWidth));
    }
    let data = [];
    for (let i = 1; i < values.rows.length; i++) {
        let dataItem = {};
        for (let col in columns) {
            dataItem[columns[col].field] = values.rows[i].values[col];
        }
        data.push(dataItem);
    }
    let gridWidget = $(`<div id="grid"></div>`);
    widget.append(gridWidget);
    gridWidget.kendoGrid({
        columns: columns,
        editable: false,
        resizable: true,
        height: h - widget.parent().parent().find(".chartHeaderTitle").outerHeight(),
        columnMenu: true,
        sortable: true,
        filterable: true,
        allowCopy: true,
        dataSource: {
            data: data
        },
        columnResize: function (e) {
            let cols = columns.filter(c => c.field == e.column.field);
            localStorage.setItem(tableColLocalStorageKey(userDashboardChartLine, columns.indexOf(cols[0])), e.newWidth);
        }
    });
    return widget;

}